// Bambody v3 PDP variant picker + ATC.
// Simpler than bambody-v3-shop.js — bound to a single product. Reads product
// data from <script data-bam-v3-pdp-data>{...}</script>, drives color/size/pack
// selection, image swap on color hover, ATC via /cart/add.js, gallery arrows.
// Fires bam:cart:added so the drawer opens (same event bambody-v3-shop.js uses).

(function () {
  const COLOR_MAP = {
    Black: '#1F0E33', Nude: '#E5C6A9', Gray: '#9A9AA0',
    'Dark Blue': '#2A3A6B', 'Dark Purple': '#4B2C7A',
    Pink: '#F5B6C7', Blue: '#8DC3E1', Green: '#B7DAB9', Lace: '#1F0E33',
  }

  function colorSlug(raw) {
    return String(raw || '').toLowerCase()
      .replace(/\s*—\s*/g, '-')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '')
  }
  function stripFlow(raw) {
    return String(raw || '').replace(/^(Heavy|Light)(?:\s+Flow)?\s*—\s*/, '').trim()
  }
  function fmtPrice(cents) {
    return '$' + ((Number(cents) || 0) / 100).toFixed(2)
  }
  function shortSize(s) {
    return String(s || '')
      .replace('XX-Small', 'XXS').replace('X-Small', 'XS').replace('Small', 'S')
      .replace('Medium', 'M')
      .replace('XX-Large', 'XXL').replace('3X-Large', '3X').replace('4X-Large', '4X').replace('5X-Large', '5X').replace('6X-Large', '6X').replace('X-Large', 'XL')
      .replace('Large', 'L')
  }

  function makeSwatchEl(colorRaw, oos) {
    const parts = stripFlow(colorRaw).replace(/\s+with\s+lace/i, '').split(/\s*\/\s*/).map((s) => s.trim()).filter(Boolean)
    const el = document.createElement('button')
    el.type = 'button'
    el.className = 'sw' + (oos ? ' oos' : '')
    if (parts.length === 1) {
      el.style.background = COLOR_MAP[parts[0]] || '#ccc'
    } else {
      const step = 360 / parts.length
      const stops = parts.map((c, i) => `${COLOR_MAP[c] || '#ccc'} ${i * step}deg ${(i + 1) * step}deg`).join(', ')
      el.style.background = `conic-gradient(from -90deg, ${stops})`
    }
    return el
  }

  let PDP = null
  const S = { color: null, size: null, pack: null, imageIndex: null }

  function loadData() {
    const el = document.querySelector('script[data-bam-v3-pdp-data]')
    if (!el) return null
    try { return JSON.parse(el.textContent) } catch { return null }
  }

  function currentVariant() {
    if (!PDP) return null
    return PDP.variants.find((v) => v.color === S.color && v.size === S.size && v.pack === S.pack) || null
  }

  // Canonical Bambody size order (XXS → 6XL). Any label not in the map sorts to the end.
  const SIZE_ORDER = ['XX-Small','X-Small','Small','Medium','Large','X-Large','XX-Large','3X-Large','4X-Large','5X-Large','6X-Large']
  const sizeRank = (s) => { const i = SIZE_ORDER.indexOf(s); return i < 0 ? 999 : i }
  // Pack order: single pair → larger bundles, consistent across products.
  const PACK_ORDER = ['1pk','2pk','3pk','4pk','5pk','6pk']
  const packRank = (s) => { const i = PACK_ORDER.indexOf(s); return i < 0 ? 999 : i }

  function allValues(axis) {
    const seen = []
    for (const v of PDP.variants) {
      const val = v[axis]
      if (val && !seen.some((x) => x.value === val)) seen.push({ value: val, available: v.available })
    }
    // Contextual availability: size respects the chosen color, pack respects color+size.
    for (const s of seen) {
      s.available = PDP.variants.some((v) => {
        if (v[axis] !== s.value || !v.available) return false
        if (axis !== 'color' && S.color && v.color !== S.color) return false
        if (axis === 'pack' && S.size && v.size !== S.size) return false
        return true
      })
    }
    if (axis === 'size') seen.sort((a, b) => sizeRank(a.value) - sizeRank(b.value))
    if (axis === 'pack') seen.sort((a, b) => packRank(a.value) - packRank(b.value))
    return seen
  }

  function selectDefaultAxes() {
    const first = PDP.variants.find((v) => v.id === PDP.defaultVariantId) || PDP.variants.find((v) => v.available) || PDP.variants[0]
    S.color = first.color
    S.size = first.size
    S.pack = first.pack
  }

  function snapToClosest() {
    if (currentVariant()) return
    const byColor = PDP.variants.filter((v) => v.color === S.color && v.available)
    const bySize = byColor.filter((v) => v.size === S.size)
    if (bySize.length) { S.pack = bySize[0].pack; return }
    if (byColor.length) { S.size = byColor[0].size; S.pack = byColor[0].pack; return }
    const anyAvail = PDP.variants.find((v) => v.available) || PDP.variants[0]
    S.color = anyAvail.color; S.size = anyAvail.size; S.pack = anyAvail.pack
  }

  // ── Renderers ──
  function renderSwatches() {
    const el = document.getElementById('bam-v3-pdp-swatch-row')
    if (!el) return
    el.innerHTML = ''
    for (const { value, available } of allValues('color')) {
      const sw = makeSwatchEl(value, !available)
      sw.title = stripFlow(value)
      if (S.color === value) sw.classList.add('active')
      sw.onclick = () => bamV3PdpSelect('color', value)
      sw.addEventListener('mouseenter', () => previewImageForColor(value))
      sw.addEventListener('mouseleave', () => previewImageForColor(null))
      el.appendChild(sw)
    }
    const cur = document.getElementById('bam-v3-pdp-color-label')
    if (cur) cur.textContent = stripFlow(S.color || '')
  }

  function renderSizes() {
    const el = document.getElementById('bam-v3-pdp-size-row')
    if (!el) return
    el.innerHTML = allValues('size').map(({ value, available }) =>
      `<button type="button" class="sz-btn${S.size === value ? ' active' : ''}${available ? '' : ' oos'}" onclick="bamV3PdpSelect('size','${value.replace(/'/g, "\\'")}')">${shortSize(value)}</button>`,
    ).join('')
  }

  function renderPacks() {
    const el = document.getElementById('bam-v3-pdp-pack-row')
    if (!el) return
    el.innerHTML = allValues('pack').map(({ value, available }) => {
      const label = value === '1pk' ? 'Single pair' : value.replace(/pk$/, '-pack') + ' bundle'
      return `<button type="button" class="pack-btn${S.pack === value ? ' active' : ''}${available ? '' : ' oos'}" onclick="bamV3PdpSelect('pack','${value}')"><span class="pack-name">${label}</span><span class="pack-sub"></span></button>`
    }).join('')
  }

  function renderBuy() {
    const v = currentVariant()
    const priceMain = document.getElementById('bam-v3-pdp-price-main')
    const priceSub = document.getElementById('bam-v3-pdp-price-sub')
    const atc = document.getElementById('bam-v3-pdp-atc-btn')
    if (!v) {
      if (priceMain) priceMain.textContent = 'Unavailable'
      if (priceSub) priceSub.textContent = ''
      if (atc) atc.disabled = true
      syncExpressForm(null)
      return
    }
    if (priceMain) priceMain.textContent = fmtPrice(v.price)
    const packLabel = v.pack === '1pk' ? 'single pair' : v.pack.replace(/pk$/, '-pack')
    if (priceSub) priceSub.textContent = packLabel
    if (atc) {
      atc.disabled = !v.available
      atc.dataset.variantId = v.id
    }
    syncExpressForm(v)
  }

  // Update the hidden variant id on the express-checkout form so payment_button submits the correct variant.
  function syncExpressForm(variant) {
    const input = document.querySelector('[data-express-id]')
    if (input && variant) input.value = variant.id
  }

  // Unique main image for the current (color, pack): pack hero if one exists
  // (bam-pack:<color>:<pack>), else the color hero, else default. colorOverride
  // previews a hovered color while keeping the selected pack.
  function mainImageFor(colorOverride) {
    const slug = colorSlug(colorOverride || S.color)
    return (S.pack && PDP.packImages?.[`${slug}:${S.pack}`]) || PDP.images?.[slug] || PDP.defaultImage || null
  }

  function renderImage() {
    const el = document.getElementById('bam-v3-pdp-img')
    if (!el) return
    const media = currentMedia()
    let url = null
    if (S.imageIndex != null && media[S.imageIndex]) {
      url = media[S.imageIndex].big
    } else {
      url = mainImageFor() || media[0]?.big || null
    }
    if (url) {
      el.src = url
      el.alt = `${PDP.title} — ${stripFlow(S.color)}`
      el.removeAttribute('data-empty')
    } else {
      el.removeAttribute('src')
      el.alt = PDP.title
      el.setAttribute('data-empty', '')
    }
    // Arrows + counter — visible only if multiple images in the current-color filter.
    const prev = document.getElementById('bam-v3-pdp-prev')
    const next = document.getElementById('bam-v3-pdp-next')
    const counter = document.getElementById('bam-v3-pdp-img-count')
    const showControls = media.length > 1
    if (prev) prev.hidden = !showControls
    if (next) next.hidden = !showControls
    if (counter) {
      if (showControls) {
        const displayIdx = S.imageIndex != null
          ? Math.min(S.imageIndex, media.length - 1)
          : Math.max(0, media.findIndex((m) => m.big === url))
        counter.textContent = `${displayIdx + 1} / ${media.length}`
        counter.hidden = false
      } else counter.hidden = true
    }
  }

  function previewImageForColor(colorRaw) {
    const el = document.getElementById('bam-v3-pdp-img'); if (!el) return
    const target = colorRaw || S.color
    const url = mainImageFor(target)
    if (!url) return
    el.src = url
    el.alt = `${PDP.title} — ${stripFlow(target)}`
  }

  // Media list powering the thumb strip AND arrow cycling.
  // Position 0 = currently-selected color's hero (follows color picker). Positions 1..N =
  // SHARED family media (info cards, cert badges, back views) — same across all colors.
  // PDP.mediaList (from Liquid) already excludes color-tagged media, so this prepend is safe.
  function currentMedia() {
    const shared = Array.isArray(PDP?.mediaList) ? PDP.mediaList : []
    const heroUrl = mainImageFor()
    if (!heroUrl) return shared
    return [{ big: heroUrl, thumb: heroUrl }, ...shared]
  }

  function renderThumbs() {
    const el = document.getElementById('bam-v3-pdp-thumbs')
    if (!el) return
    const media = currentMedia()
    if (media.length <= 1) { el.innerHTML = ''; return }
    const currentSrc = document.getElementById('bam-v3-pdp-img')?.getAttribute('src')
    const activeIdx = (S.imageIndex != null)
      ? Math.min(S.imageIndex, media.length - 1)
      : Math.max(0, media.findIndex((m) => m.big === currentSrc))
    el.innerHTML = media.map((m, i) => {
      const cls = 'bam-v3-pdp__thumb' + (i === activeIdx ? ' active' : '')
      return `<button type="button" class="${cls}" onclick="bamV3PdpPickImage(${i})" aria-label="Image ${i + 1}"><img src="${m.thumb}" alt=""></button>`
    }).join('')
  }

  window.bamV3PdpPickImage = function (idx) {
    const media = currentMedia()
    if (idx < 0 || idx >= media.length) return
    S.imageIndex = idx
    renderImage()
    renderThumbs()
  }

  // Populate the global #bam-v3-sticky-bar with the CURRENT product's state.
  // Simpler than the homepage sticky (no popover picker) — the on-page variant
  // picker already exists above, so the sticky is just a persistent buy shortcut.
  function renderPdpSticky() {
    const bar = document.getElementById('bam-v3-sticky-bar')
    if (!bar || !PDP) return
    const v = currentVariant()
    if (!v) return
    const slug = colorSlug(S.color)
    const url = PDP.images?.[slug] || PDP.defaultImage || ''
    const packLabel = (v.pack || '').replace(/pk$/, '-pack').replace('1-pack', 'Single')
    bar.innerHTML = `
      <div class="sb-left">
        <div class="sb-thumb-wrap">
          ${url ? `<img src="${url}" alt="${PDP.title}" class="sb-thumb">` : ''}
        </div>
        <div class="sb-info">
          <div class="sb-name">${PDP.title}</div>
          <div class="sb-chips">
            <button type="button" class="sb-chip" onclick="event.stopPropagation();bamV3PdpStickyOpen('color', event)" onmouseenter="event.stopPropagation();bamV3PdpStickyHover('color')" onmouseleave="event.stopPropagation();bamV3PdpStickyHoverEnd()">${stripFlow(S.color || 'Colour')}</button>
            <button type="button" class="sb-chip" onclick="event.stopPropagation();bamV3PdpStickyOpen('size', event)" onmouseenter="event.stopPropagation();bamV3PdpStickyHover('size')" onmouseleave="event.stopPropagation();bamV3PdpStickyHoverEnd()">${shortSize(S.size || 'Size')}</button>
            <button type="button" class="sb-chip" onclick="event.stopPropagation();bamV3PdpStickyOpen('pack', event)" onmouseenter="event.stopPropagation();bamV3PdpStickyHover('pack')" onmouseleave="event.stopPropagation();bamV3PdpStickyHoverEnd()">${packLabel || 'Pack'}</button>
          </div>
        </div>
      </div>
      <div class="sb-right">
        <div class="sb-price">${fmtPrice(v.price)}</div>
        <button type="button" class="sb-cta" onclick="bamV3PdpAddToCart()"${v.available ? '' : ' disabled'}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 002 1.58h9.78a2 2 0 001.95-1.57l1.65-7.43H5.12"/></svg>
          ${v.available ? 'Add to cart' : 'Sold out'}
        </button>
      </div>
    `
  }

  // ── Sticky-bar variant popovers (colour / size / pack) — mirrors the shop sticky,
  //    but drives the PDP state so the sticky pill can change variant on mobile + desktop. ──
  let pdpHoverCloseTimer = null
  const PDP_HOVER_CLOSE_MS = 220
  function pdpScheduleHoverClose() {
    clearTimeout(pdpHoverCloseTimer)
    pdpHoverCloseTimer = setTimeout(() => { pdpHoverCloseTimer = null; pdpClosePopover() }, PDP_HOVER_CLOSE_MS)
  }
  function pdpCancelHoverClose() { clearTimeout(pdpHoverCloseTimer); pdpHoverCloseTimer = null }
  function pdpClosePopover() {
    pdpCancelHoverClose()
    document.querySelectorAll('#bam-v3-sticky-bar .sb-popover').forEach((el) => el.remove())
  }
  window.bamV3PdpStickyHover = function (axis) {
    pdpCancelHoverClose()
    const bar = document.getElementById('bam-v3-sticky-bar')
    if (!bar) return
    if (bar.querySelector(`.sb-popover[data-anchor="${axis}"]`)) return
    pdpStickyRender(axis)
  }
  window.bamV3PdpStickyHoverEnd = function () { pdpScheduleHoverClose() }
  window.bamV3PdpStickyOpen = function (axis, ev) {
    if (ev) ev.stopPropagation()
    const bar = document.getElementById('bam-v3-sticky-bar')
    if (!bar) return
    if (axis === null) { pdpClosePopover(); return }
    if (bar.querySelector(`.sb-popover[data-anchor="${axis}"]`)) { pdpClosePopover(); return }
    pdpStickyRender(axis)
  }
  function pdpStickyRender(axis) {
    const bar = document.getElementById('bam-v3-sticky-bar')
    if (!bar) return
    pdpClosePopover()
    const pop = document.createElement('div')
    pop.className = 'sb-popover'
    pop.setAttribute('data-anchor', axis)
    pop.addEventListener('mouseenter', pdpCancelHoverClose)
    pop.addEventListener('mouseleave', pdpScheduleHoverClose)
    let inner = ''
    if (axis === 'color') {
      const items = allValues('color').map(({ value, available }) => {
        const parts = stripFlow(value).replace(/\s+with\s+lace/i, '').split(/\s*\/\s*/).map((s) => s.trim()).filter(Boolean)
        let bg = ''
        if (parts.length === 1) bg = COLOR_MAP[parts[0]] || '#ccc'
        else {
          const step = 360 / parts.length
          bg = 'conic-gradient(from -90deg,' + parts.map((c, i) => `${COLOR_MAP[c] || '#ccc'} ${i * step}deg ${(i + 1) * step}deg`).join(',') + ')'
        }
        const cls = 'sb-popover-swatch' + (S.color === value ? ' active' : '') + (available ? '' : ' oos')
        const val = value.replace(/'/g, "\\'")
        return `<button type="button" class="${cls}" style="background:${bg}" title="${stripFlow(value)}" onclick="bamV3PdpSelect('color','${val}');bamV3PdpStickyOpen(null)"></button>`
      }).join('')
      inner = `<div class="sb-popover-title">Colour</div><div class="sb-popover-swatches">${items}</div>`
    } else if (axis === 'size' || axis === 'pack') {
      const items = allValues(axis).map(({ value, available }) => {
        const label = axis === 'size' ? shortSize(value) : (value === '1pk' ? 'Single' : value.replace(/pk$/, '-pack'))
        const cls = 'sb-popover-opt' + (S[axis] === value ? ' active' : '') + (available ? '' : ' oos')
        const val = value.replace(/'/g, "\\'")
        return `<button type="button" class="${cls}" onclick="bamV3PdpSelect('${axis}','${val}');bamV3PdpStickyOpen(null)">${label}</button>`
      }).join('')
      const title = axis === 'size' ? 'Size' : 'Pack'
      inner = `<div class="sb-popover-title">${title}</div><div class="sb-popover-grid">${items}</div>`
    } else { return }
    pop.innerHTML = inner
    bar.appendChild(pop)
    setTimeout(() => {
      document.addEventListener('click', function onDocClick(e) {
        if (!bar.contains(e.target)) { pdpClosePopover(); document.removeEventListener('click', onDocClick) }
      })
    }, 0)
  }

  function renderAll() {
    renderSwatches(); renderSizes(); renderPacks(); renderBuy(); renderImage(); renderThumbs(); renderPdpSticky()
  }

  window.bamV3PdpSelect = function (axis, value) {
    S[axis] = value
    snapToClosest()
    if (axis === 'color' || axis === 'pack') S.imageIndex = null
    renderAll()
  }

  // ── Gallery arrows — cycle through the current-color-filtered media only ──
  function stepImage(delta) {
    const media = currentMedia()
    if (media.length <= 1) return
    if (S.imageIndex == null) {
      const currentUrl = document.getElementById('bam-v3-pdp-img')?.getAttribute('src')
      const idx = currentUrl ? media.findIndex((m) => m.big === currentUrl) : -1
      S.imageIndex = idx >= 0 ? idx : 0
    }
    S.imageIndex = (S.imageIndex + delta + media.length) % media.length
    renderImage()
    renderThumbs()
  }
  window.bamV3PdpPrevImage = function () { stepImage(-1) }
  window.bamV3PdpNextImage = function () { stepImage(1) }

  // ── ATC ──
  const ICON_CART = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 002 1.58h9.78a2 2 0 001.95-1.57l1.65-7.43H5.12"/></svg>'
  const ICON_CHECK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
  const SPINNER = '<span class="bam-v3-spin" aria-hidden="true"></span>'

  function setBtn(state) {
    const btn = document.getElementById('bam-v3-pdp-atc-btn'); if (!btn) return
    btn.classList.remove('added')
    btn.disabled = state === 'loading'
    if (state === 'loading') btn.innerHTML = `${SPINNER}<span>Adding…</span>`
    else if (state === 'success') { btn.classList.add('added'); btn.innerHTML = `${ICON_CHECK}<span>Added</span>` }
    else { btn.innerHTML = `${ICON_CART} Add to cart`; const v = currentVariant(); btn.disabled = !(v && v.available) }
  }

  window.bamV3PdpAddToCart = async function () {
    const v = currentVariant(); if (!v || !v.available) return
    setBtn('loading')
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
      })
      if (!res.ok) throw new Error('add-to-cart failed')
      const item = await res.json().catch(() => null)
      setBtn('success')
      document.dispatchEvent(new CustomEvent('bam:cart:added', { detail: { variantId: v.id, item } }))
      setTimeout(() => setBtn('idle'), 1500)
    } catch (e) { console.error(e); setBtn('idle') }
  }

  // Size guide modal — opens on "size guide →" click. Close on backdrop / X / ESC.
  window.bamV3PdpOpenSizeGuide = function () {
    const m = document.getElementById('bam-v3-pdp-size-modal')
    if (!m) return
    m.setAttribute('data-open', '')
    m.setAttribute('aria-hidden', 'false')
    document.body.style.overflow = 'hidden'
  }
  window.bamV3PdpCloseSizeGuide = function () {
    const m = document.getElementById('bam-v3-pdp-size-modal')
    if (!m) return
    m.removeAttribute('data-open')
    m.setAttribute('aria-hidden', 'true')
    document.body.style.overflow = ''
  }
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    const m = document.getElementById('bam-v3-pdp-size-modal')
    if (m?.hasAttribute('data-open')) bamV3PdpCloseSizeGuide()
  })

  // ── Init ──
  document.addEventListener('DOMContentLoaded', () => {
    PDP = loadData()
    if (!PDP) return
    selectDefaultAxes()
    renderAll()
  })
})();
